import React, { useEffect, useRef, useState } from 'react';

import {
	Switch,
	Route,
	// Link,
	useRouteMatch,
	useParams,
} from 'react-router-dom';

import { useSelector, useDispatch } from 'react-redux';

import makeStyles from '@mui/styles/makeStyles';
import { useTranslation } from 'react-i18next';

import API from '../../app/api';

import _ from 'lodash';
import moment from 'moment';
import clsx from 'clsx';

import config from '../../app/config';

import { loadPatientById, patient, setPatient } from '../../store/reducers/patient';
import {
	loadDocumentsForPatientById,
	documents,
	studies,
	studiesGroup,
	setDocuments,
} from '../../store/reducers/documents';
import { updateScroll } from '../../store/reducers/globals';

import ToolbarDICOM from './toolbarDICOM';
import { loadPatientWithDocuments } from '../../util/loaders';

import Image from '../../controls/image';
import ImageNative from '../../controls/imageNative';
import PerfectScrollbar from 'react-perfect-scrollbar';
import Patients from '../patients/patients';

import Thumbnail from "../patient//thumbnail";

import ViewerUtils from './utils';
import ViewDocumentDicom from './viewDocumentDicom';
import ViewDocumentNonDicom from './viewDocumentNonDicom';

const useStyles = (pref) => makeStyles((theme) => ({
	parentMain: {
		width: '100%',
		height: '100%',
		border: '0 !important',
	},
	base: {
		width: '100%',
		height: pref.previewVisible ? 'calc(100% - 151px)' : '100%',
		border: '0 !important',
	},
	thumbs: {
		width: '100%',
		height: '151px',
		padding: '0 7px',
		// border: '0 !important',
		backgroundColor: "#333",
		border: '1px solid #555 !important',
		whiteSpace: "nowrap",
	},
	thumb: {
		display: "inline-block",
	},
}));

function ViewDocument(props) {
	const dispatch = useDispatch();
	const classes = useStyles({ previewVisible: props.previewVisible })();

	const patientObject = useSelector(patient);
	const documentsObject = useSelector(documents);

	const viewerUtils = new ViewerUtils(documentsObject.__data);

	//
	// console.log('getStudy', viewerUtils.getStudy(props.document));
	// console.log('getLaterality', viewerUtils.getLaterality(props.document));
	// console.log('getStudyDocuments', viewerUtils.getStudyDocuments(viewerUtils.getStudy(props.document)));
	// console.log('getDocumentPositionInStudy', viewerUtils.getDocumentPositionInStudy(props.document));

	// console.log('getLaterality R', viewerUtils.getStudyDocuments(viewerUtils.getStudy(props.document), "R").length);
	// console.log('getLaterality L', viewerUtils.getStudyDocuments(viewerUtils.getStudy(props.document), "L").length);
	// console.log('getLaterality B', viewerUtils.getStudyDocuments(viewerUtils.getStudy(props.document), "B").length);
	// console.log('getLateralityMaxLen', viewerUtils.getLateralityMaxLen(viewerUtils.getStudy(props.document)));

	useEffect(() => {
		if (documentsObject) {
		}
	}, [documentsObject]);

	const openDocument = (document) => () => {
		// FIXME: do something when hiostory mode is active !!! 
		props.openDocument(document);
	};

	const getImgUrl = (document) => {
		const imgSize = config.modules.thumbnail.size["small"].loadWidth;
		let imgURL = `${config.apiUrl}/patients/${props.patientId}/documents/${document.__id}/pages/1/preview/lo/image?size=${imgSize}&Authorization=${window.keycloak ? window.keycloak.token : window.auth.token}`;
		if (document.__haveLoadError) {
			imgURL = "/image/error.png";
		}

		return imgURL;
	};

	return (
		<div className={classes.parentMain}>
			<div className={classes.base}>
                {props.document && props.document.metadata && props.dicom && <ViewDocumentDicom {...props} /> }
				{props.document && props.document.metadata && !props.dicom && <ViewDocumentNonDicom {...props} />}
			</div>
			{props.previewVisible &&
				<div className={classes.thumbs}>
					<PerfectScrollbar
						options={{
							useBothWheelAxes: true
						}}
					>
						{props.documents.map((documentToView, idx) => (
							<div className={classes.thumb}>
								<Thumbnail
									document={documentToView}
									onOpenDocument={openDocument(documentToView)}
									thumbActive={documentToView === props.document}
									imageUrl={getImgUrl(documentToView)} size={"small"} />
							</div>
						))}
					</PerfectScrollbar>
				</div>
			}
		</div>
	);
}

export default ViewDocument;
